import React from 'react'
import {Box, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import {Link as RouterLink} from 'react-router-dom'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import useDamImage from '../../custom-hooks/use-dam-image'
import {remCalc} from '../../theme/_utils'
import {getGlobalLink, safeBuildUrl} from '../../utils/contentstack-utils'

const defaultColors = {
    blue: '#E1E1E3',
    grey: '#E2DCD5',
    red: '#EFE0DD',
}

const DrawerImageCard = ({imageCard, categoriesData = {}, locale = {}}) => {
    const {buildUrl} = useMultiSite()
    const damImage = useDamImage(imageCard?.image)
    const innerCard = imageCard?.card ?? {}
    const cardConfig = {
        backgroundColor:
            defaultColors[innerCard?.card_color?.toLowerCase()] || defaultColors['grey'],
        icon: innerCard?.icon,
        redirect: imageCard?.type === 'image' ? imageCard?.image?.redirect : innerCard?.redirect,
        subtitle_text: innerCard?.subtitle_text,
        title_text: innerCard?.title_text,
    }

    const {label, url, isAbsolute} = getGlobalLink({
        link: cardConfig?.redirect,
        categoriesData,
        locale: locale?.alias,
    })

    const tileUrl = isAbsolute ? url : safeBuildUrl(url, buildUrl)
    const isTileLink = Boolean(tileUrl)

    return (
        <Box
            as={isTileLink ? (isAbsolute ? 'a' : RouterLink) : 'div'}
            href={isAbsolute ? tileUrl : undefined}
            to={!isAbsolute ? tileUrl : undefined}
            target={isAbsolute ? '_blank' : undefined}
            rel={isAbsolute ? 'noopener noreferrer' : undefined}
            aria-label={label || cardConfig?.title_text}
            _hover={isTileLink ? {textDecoration: 'none'} : undefined}
            minW={{
                base: remCalc(148),
                sm: remCalc(148),
                md: remCalc(280),
            }}
            w={{
                base: '100%',
                sm: '100%',
                md: remCalc(280),
            }}
            aspectRatio={1}
            bgImage={damImage?.url ? `url(${damImage.url})` : undefined}
            bgSize="cover"
            bgPosition="center"
            bgRepeat="no-repeat"
            backgroundColor={imageCard?.type === 'card' ? cardConfig?.backgroundColor : undefined}
            position="relative"
            borderRadius="large-1"
        >
            {imageCard?.type === 'card' && (
                <Box
                    position="absolute"
                    top="50%"
                    transform="translateY(-50%)"
                    textAlign="center"
                    w="100%"
                >
                    <Text textStyle="body-large" fontWeight="medium">
                        {cardConfig?.title_text}
                    </Text>
                    <Text textStyle="body-medium" fontWeight="normal">
                        {cardConfig?.subtitle_text}
                    </Text>
                </Box>
            )}
        </Box>
    )
}

DrawerImageCard.propTypes = {
    imageCard: PropTypes.object,
    locale: PropTypes.object,
    categoriesData: PropTypes.object,
}
export default DrawerImageCard
